import React from 'react';

import './PageSkeleton.scss';

export function PageSkeleton({ cards }) {
  if (cards) {
    return (
      <div className='page-skeleton page-skeleton--cards' aria-busy='true'>
        {[0, 1, 2, 3].map(i => (
          <div key={i} className='skeleton-card'>
            <div className='skeleton-card-head'>
              <span className='skeleton-line skeleton-line--title' />
              <span className='skeleton-dot' />
            </div>
            <span className='skeleton-bar' />
            <div className='skeleton-card-info'>
              <span className='skeleton-line' />
              <span className='skeleton-line skeleton-line--70' />
              <span className='skeleton-line skeleton-line--50' />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className='page-skeleton page-skeleton--chart' aria-busy='true'>
      <span className='skeleton-line skeleton-line--title' />
      <div className='skeleton-chart' />
    </div>
  );
}

export function HeaderSkeleton() {
  return (
    <div className='header_stack'>
      <div className='top_header header-skeleton' aria-busy='true'>
        <span className='skeleton-pill skeleton-pill--sync' />
        <span className='skeleton-pill skeleton-pill--selector' />
        <span className='skeleton-pill skeleton-pill--actions' />
      </div>
    </div>
  );
}

export default PageSkeleton;
